import { getAppId } from 'src/core/classes/helpers/getAppId'
import { getActiveTokens } from 'src/core/classes/helpers/StorageHelper'
import { HttpHeaders, Rest } from 'src/core/classes/http'
import { getProcedureUrl } from 'src/core/store/service/helpers/getBaseUrl'
import Logger from 'src/core/utils/Logger'

export const callProcedure = async (procedureName: string, payloadData: object = {}) => {
  const url = getProcedureUrl(procedureName)
  const [accessToken] = getActiveTokens()

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    AppId: getAppId(),
    ...payloadData,
  }

  const response = await Rest.post({ url, payload, headers }).catch(Logger.error)

  if (response?.Errors) {
    throw new Error(response.Errors)
  }
  return response['Data'] || []
}
